import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchApiKeyDetailsByCustomerId, generateNewApiKeyForCustomer, fetchApiKeyDetailsByTenantId, generateNewApiKeyForTenant } from '../store/entities/customers';
import { globalViewText } from '../utilities/config'
import LoaderWrapper from './common/LoaderWrapper/LoaderWrapper';
import Style from './SocIntegration.module.css';

class SOCHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showCustomerApiKey: false,
            showTenantApiKey: false,
        };
    }

    componentDidMount = () => {
        if (this.props.selectedCustomer) {
            this.props.fetchApiKeyDetailsByCustomerId(this.props.selectedCustomer.id);
            if (this.props.tokenRoles === "TenantAdmin" || this.props.tokenRoles === "PixmAdmin")
                this.props.fetchApiKeyDetailsByTenantId(this.props.selectedCustomer.tenantId);
        } 
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.selectedCustomer !== prevProps.selectedCustomer) {
            this.props.fetchApiKeyDetailsByCustomerId(this.props.selectedCustomer.id);
            if (this.props.tokenRoles === "TenantAdmin" || this.props.tokenRoles === "PixmAdmin")
                this.props.fetchApiKeyDetailsByTenantId(this.props.selectedCustomer.tenantId);
        }
    }

    generateNewCustomerApiKey = () => {
        if (this.props.selectedCustomer) {
            this.props.generateNewApiKeyForCustomer(this.props.selectedCustomer.id)
        }
    }

    generateNewTenantApiKey = () => {
        if (this.props.selectedCustomer) {
            this.props.generateNewApiKeyForTenant(this.props.selectedCustomer.tenantId)
        }
    }

    fetchExpiryDateDetails = () => {
        const { apiKeyExpiryDate, tenantApiKeyExpiryDate } = this.props;
        var expiryDate = apiKeyExpiryDate ? new Date(apiKeyExpiryDate) : null;
        var expiryDateString = expiryDate ? expiryDate.toISOString().split('T')[0] : null;
        var tenantApiExpiry = tenantApiKeyExpiryDate ? new Date(tenantApiKeyExpiryDate) : null;
        var tenantApiExpiryDateString = tenantApiExpiry ? tenantApiExpiry.toISOString().split('T')[0] : null;
        return { expiryDateString, tenantApiExpiryDateString };
    }

    fetchCurrentDateDetails = () =>{
        var priorDate = new Date();
        priorDate.setDate(priorDate.getDate() - 30);
        var priorDateString = priorDate.toISOString().split('T')[0];
        var today = new Date();
        var todayString = today.toISOString().split('T')[0];
        return { priorDateString, todayString };
    }

    render() {
        if (!this.props.selectedCustomer)
            return null;

        const { showCustomerApiKey, showTenantApiKey } = this.state;
        const { apiKey, tenantApiKey, showGlobalKey, showCustomerKey } = this.props
        const { expiryDateString, tenantApiExpiryDateString } = this.fetchExpiryDateDetails();
        const isTA = this.props.tokenRoles === "TenantAdmin";
        const isPA = this.props.tokenRoles === "PixmAdmin";
        const isGlobalView = this.props.selectedCustomer.organizationName === globalViewText
        let { title, description } = this.props;

        return (<>
                <div className={`mt-4`}>
                    <div className={`${Style.titleStyle}`}>
                        {title}
                    </div>
                    {!isGlobalView && showCustomerKey ?
                        <LoaderWrapper loading={this.props.loading} waitForData={false} styles={{minHeight: '100px'}} isFlex={true}>
                            <>
                            <div className={`${Style.headContainer} mt-4 px-5 d-flex align-items-center flex-grow-1`} style={{ justifyContent: 'space-between' }}>
                                {apiKey ?
                                    <>
                                        <div className={`px-4`} style={{ whiteSpace: 'nowrap' }}>
                                            <div className={`${Style.fontBold}`}>
                                                Current API key.
                                            </div>
                                            <div
                                                className={`${Style.fontBold} ${Style.cursorPointer}`}
                                                onClick={() => { this.setState({ showCustomerApiKey: true }) }}
                                            >
                                                {showCustomerApiKey ? apiKey : 'Click to show API key.'}
                                            </div>
                                            <div className={`${Style.textStyle}`}>The API key is valid till <b>{expiryDateString}</b></div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className={`px-4`}>
                                            <div className={`${Style.fontBold}`}>
                                                Click on the 'Generate' button to create and assign new API Key.
                                            </div>
                                        </div>
                                    </>
                                }
                                <div>
                                    <div className={'d-flex'}>
                                        <button className={`${Style.submitButton} focus-none px-4`} onClick={() => this.generateNewCustomerApiKey()}>Generate new API Key</button>
                                    </div>
                                </div>
                            </div>
                            </>
                        </LoaderWrapper>
                    : null}
                    {isTA && showGlobalKey ?
                        <LoaderWrapper loading={this.props.loading} waitForData={false} styles={{minHeight: '100px'}} isFlex={true}>
                            <>
                                <div className={`${Style.headContainer} mt-4 px-5 d-flex align-items-center flex-grow-1`} style={{ justifyContent: 'space-between' }}>
                                    {tenantApiKey ?
                                        <>
                                            <div className={`px-4`} style={{ whiteSpace: 'nowrap' }}>
                                                <div className={`${Style.fontBold}`}>
                                                    Current Global API key.
                                                </div>
                                                <div>
                                                    <div
                                                        className={`${Style.fontBold} ${Style.cursorPointer}`}
                                                        onClick={() => { this.setState({ showTenantApiKey: true }) }}

                                                    >
                                                        {showTenantApiKey ? tenantApiKey : 'Click to show Global API key.'}
                                                        <div>
                                                        </div>
                                                    </div>
                                                    <div className={`${Style.textStyle}`}>The API key is valid till <b>{tenantApiExpiryDateString}</b></div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className={`px-4`}>
                                                <div className={`${Style.fontBold}`}>
                                                    Click on the 'Generate' button to create and assign new Global API Key.
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className={'d-flex'}>
                                        <button className={`${Style.submitButton} focus-none px-4`} onClick={() => this.generateNewTenantApiKey()}>Generate new Global API Key</button>
                                    </div>
                                </div>
                            </>
                        </LoaderWrapper>
                    : null}
                    {isPA && isGlobalView && showGlobalKey?
                        <LoaderWrapper loading={this.props.loading} waitForData={false} styles={{minHeight: '100px'}} isFlex={true}>
                            <>
                                <div className={`${Style.headContainer} mt-4 px-5 d-flex align-items-center flex-grow-1`} style={{ justifyContent: 'space-between' }}>
                                    {tenantApiKey ?
                                        <>
                                            <div className={`px-4`} style={{ whiteSpace: 'nowrap' }}>
                                                <div className={`${Style.fontBold}`}>
                                                    Current Global API key.
                                                </div>
                                                <div>
                                                    <div
                                                        className={`${Style.fontBold} ${Style.cursorPointer}`}
                                                        onClick={() => { this.setState({ showTenantApiKey: true }) }}

                                                    >
                                                        {showTenantApiKey ? tenantApiKey : 'Click to show Global API key.'}
                                                        <div>
                                                        </div>
                                                    </div>
                                                    <div className={`${Style.textStyle}`}>The API key is valid till <b>{tenantApiExpiryDateString}</b></div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className={`px-4`}>
                                                <div className={`${Style.fontBold}`}>
                                                    Click on the 'Generate' button to create and assign new Global API Key.
                                                </div>
                                            </div>
                                        </>
                                    }
                                    <div className={'d-flex'}>
                                        <button className={`${Style.submitButton} focus-none px-4`} onClick={() => this.generateNewTenantApiKey()}>Generate new Global API Key</button>
                                    </div>
                                </div>
                            </>
                        </LoaderWrapper>
                    : null}
                </div>

                <div className={`${Style.subInfoContainerStyle} ${Style.textStyle} p-4 mt-4 w-100 mr-3`}>
                    {description}
                </div>

        </>)
    }
}

const mapStateToProps = (state) => ({
    loading: state.entities.customers.loading,
    apiKey: state.entities.customers.apiKey,
    apiKeyExpiryDate: state.entities.customers.apiKeyExpiryDate,
    tenantApiKey: state.entities.customers.tenantApiKey,
    tenantApiKeyExpiryDate: state.entities.customers.tenantApiKeyExpiryDate,
    selectedCustomer: state.entities.customers.selected,
    tokenRoles: state.entities.user.roles,
    licenseType: state.entities.customers.selected?.licenseType
})

const mapDispatchToProps = (dispatch) => ({
    fetchApiKeyDetailsByCustomerId: (customerId) => dispatch(fetchApiKeyDetailsByCustomerId(customerId)),
    generateNewApiKeyForCustomer: (customerId) => dispatch(generateNewApiKeyForCustomer(customerId)),
    fetchApiKeyDetailsByTenantId: (tenantId) => dispatch(fetchApiKeyDetailsByTenantId(tenantId)),
    generateNewApiKeyForTenant: (tenantId) => dispatch(generateNewApiKeyForTenant(tenantId))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SOCHeader))